import { IconButton, Typography, makeStyles } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import clsx from 'clsx'
import React from 'react'

const useStyles = makeStyles(theme => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1)
    },
    fullScreenCloseButton: {
        color: 'white'
    }
}))

export default function CustomDialogTitle({
    title,
    subtitle,
    onClose,
    isFullScreen
}) {
    const classes = useStyles()
    return (
        <>
            <Typography variant="h6">{title}</Typography>
            {subtitle && <Typography variant="body1">{subtitle}</Typography>}
            <IconButton
                onClick={onClose}
                className={clsx(
                    classes.closeButton,
                    isFullScreen && classes.fullScreenCloseButton
                )}
            >
                <CloseIcon />
            </IconButton>
        </>
    )
}
